import PageNames from './page-names'

export default {
  [PageNames.PAYMENT_BOOTSTRAP]: () => import('./payment-bootstrap'),
  [PageNames.PAYMENT_BOOTSTRAP_EXPRESS]: () => import('./payment-bootstrap-express'),
  [PageNames.PAYMENT_SUCCESS]: () => import('./payment-success'),
  [PageNames.PAYMENT_FAILURE]: () => import('./payment-failure'),
  [PageNames.PAYMENT_CANCEL]: () => import('./payment-cancel'),
  [PageNames.PAYMENT_ERROR]: () => import('./payment-error'),
  [PageNames.PAYMENT_NOT_FOUND]: () => import('./payment-not-found'),
  [PageNames.PAYMENT_MANUAL_IDENTIFICATION]: () => import('./payment-manual-identification'),
  [PageNames.PAYMENT_MANUAL_IDENTIFICATION_CONSUMER]: () =>
    import('./payment-manual-identification-consumer'),
  [PageNames.DISTRIBUTION_PAYMENT]: () => import('./distribution-payment'),
  [PageNames.DISTRIBUTION_PAYMENT_REDESIGN]: () => import('./distribution-payment-redesign'),
  [PageNames.DISTRIBUTION_PAYMENT_ERROR]: () => import('./distribution-payment-error'),
  [PageNames.CAMPAIGN_NOT_FOUND]: () => import('./not-found'),
  [PageNames.CHECKIN_NOT_FOUND]: () => import('./not-found'),
  [PageNames.ELIGIBILITY_PRE_ASSESSMENT]: () => import('./eligibility-pre-assessment'),
  [PageNames.ELIGIBILITY_ASSESSMENT]: () => import('./eligibility-assessment'),
  [PageNames.ELIGIBILITY_SUCCESS]: () => import('./eligibility-success'),
  [PageNames.ELIGIBILITY_FAILURE]: () => import('./eligibility-failure'),
  [PageNames.ELIGIBILITY_ERROR]: () => import('./checkin-error'),
  [PageNames.ADDRESS_SUCCESS]: () => import('./address-success'),
  [PageNames.ADDRESS_ERROR]: () => import('./checkin-error'),
  [PageNames.BLOCKED_SESSION_SHARING]: () => import('./blocked-session-sharing'),
  [PageNames.GENERIC_ERROR]: () => import('./generic-error'),
  [PageNames.INSTANT_SHOPPING_BOOTSTRAP]: () => import('./instant-shopping-bootstrap'),
  [PageNames.INSTANT_SHOPPING_SUCCESS]: () => import('./payment-success/instant-shopping'),
  [PageNames.INSTANT_SHOPPING_FAILURE]: () => import('./instant-shopping-failure'),
  [PageNames.INSTANT_SHOPPING_CANCEL]: () => import('./instant-shopping-cancel'),
  [PageNames.INSTANT_SHOPPING_ERROR]: () => import('./instant-shopping-error'),
  [PageNames.TOKEN_SIGNUP_BOOTSTRAP]: () => import('./token-signup-bootstrap'),
  [PageNames.SHOPPING_WALLET_BOOTSTRAP]: () => import('./shopping-wallet-bootstrap'),
  [PageNames.SHOPPING_WALLET_BOOTSTRAP_STEPS]: () => import('./shopping-wallet-bootstrap'),
  [PageNames.SHOPPING_WALLET_BOOTSTRAP_SINGLE_STEP]: () => import('./shopping-wallet-bootstrap'),
  [PageNames.IST_BOOTSTRAP]: () => import('./in-store-tokens-bootstrap'),
  [PageNames.IST_AUTHENTICATION]: () => import('./in-store-tokens-authentication'),
  [PageNames.IST_ERROR]: () => import('./in-store-tokens-error'),
  [PageNames.IST_SIGNUP_SUCCESS]: () => import('./in-store-tokens-signup-success'),
  [PageNames.QR_EXPIRED]: () => import('./qr-expired'),
  [PageNames.IST_DEMO_TOOL]: () => import('./ist-demo-tool'),
  [PageNames.STATIC_QR_DEMO]: () => import('./static-qr-demo')
}
